module.exports = __webpack_public_path__ + "img/4200.64e96bba.jpg";